import { Action } from "../../store/types";
import { Color } from "../../models";
import * as actions from "./actions";

export interface ColorChoiceState {
  colors: Color[];
  chosenColor?: Color;
  isColorsLoading: boolean;
  customColorsChecked: boolean;
}

const initState: ColorChoiceState = {
  colors: [],
  chosenColor: undefined,
  isColorsLoading: false,
  customColorsChecked: false,
};

export default function(
  state = initState,
  { type, payload }: Action,
): ColorChoiceState {
  switch (type) {
    case actions.SET_COLORS:
      return { ...state, colors: payload };
    case actions.SET_CHOSEN_COLOR:
      return { ...state, chosenColor: payload, customColorsChecked: false };
    case actions.TOGGLE_CHECKBOX:
      return { ...state, customColorsChecked: !state.customColorsChecked };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/reducer.ts